"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFundingRateCountDown = exports.calculateTimeOffsetCountDown = exports.useFutureFundingRate = exports.queryFutureFundingRate = void 0;
const DateUtils_1 = require("../../../TradeUtils/DateUtils");
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const queryFutureFundingRate = (base, quote, futureApi) => {
    return futureApi.getLastFundingRate(base, quote).pipe((0, operators_1.map)((result) => {
        if (result && result.length) {
            const model = {
                rate: trade_utils_lib_1.NumberCommonUtils.toPercent(new trade_utils_lib_1.SafeDecimal(result[0].last_funding_rate).mul(100), false, true, 4),
                time: result[0].next_funding_time,
            };
            return model;
        }
        return undefined;
    }));
};
exports.queryFutureFundingRate = queryFutureFundingRate;
const useFutureFundingRate = (base, quote, futureApi, isFocused = true) => {
    const [rate, setRate] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        setRate(undefined);
    }, [base, quote]);
    (0, react_1.useEffect)(() => {
        if (!base || !quote || !isFocused || !futureApi) {
            return;
        }
        const sub = (0, rxjs_1.interval)(10000)
            .pipe((0, operators_1.startWith)(0))
            .pipe((0, operators_1.mergeMap)(() => {
            return (0, trade_utils_lib_1.requestWithRetry)(() => {
                return (0, exports.queryFutureFundingRate)(base, quote, futureApi);
            }, { maxRetryCount: 1 });
        }))
            .pipe((0, operators_1.catchError)((error) => {
            console.log(error);
            return (0, rxjs_1.of)(undefined);
        }))
            .subscribe({
            next: (data) => {
                if (data) {
                    setRate(data);
                }
            },
            error: (error) => { }
        });
        return () => {
            sub && sub.unsubscribe();
        };
    }, [base, quote, isFocused, futureApi]);
    return rate;
};
exports.useFutureFundingRate = useFutureFundingRate;
// 以时间间隔倒计时: period - (now % period)
const calculateTimeOffsetCountDown = (period) => {
    const periodDecimal = new trade_utils_lib_1.SafeDecimal(period);
    const now = new trade_utils_lib_1.SafeDecimal(new Date().getTime());
    const offset = periodDecimal.sub(now.mod(periodDecimal)).toNumber();
    return (0, DateUtils_1.FormatSeconds)(offset);
};
exports.calculateTimeOffsetCountDown = calculateTimeOffsetCountDown;
// date: 终点时间的时间戳.
// 如果结果为负数, 则以8小时取余来计算
const useFundingRateCountDown = (date, isActive = true) => {
    const [time, setTime] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        if (!isActive) {
            return;
        }
        const sub = (0, rxjs_1.interval)(1000)
            .pipe((0, operators_1.startWith)(0))
            .pipe((0, operators_1.map)(() => {
            if (!date) {
                // 8小时 = 1000 * 60 * 60 * 8 = 28800000 ms
                return (0, exports.calculateTimeOffsetCountDown)(28800000);
            }
            const now = new Date().getTime();
            const offset = new trade_utils_lib_1.SafeDecimal(date).sub(now).toNumber();
            if (offset < 0) {
                // 8小时 = 1000 * 60 * 60 * 8 = 28800000 ms
                return (0, exports.calculateTimeOffsetCountDown)(28800000);
            }
            return (0, DateUtils_1.FormatSeconds)(offset);
        }))
            .subscribe({
            next: (data) => {
                setTime(data);
            },
            error: (error) => { }
        });
        return () => {
            sub.unsubscribe();
        };
    }, [date, isActive]);
    return time;
};
exports.useFundingRateCountDown = useFundingRateCountDown;
